import React from 'react'

function PageHead({ title }) {
    return (
        <div className='w-full relative space-y-1'>
            <h1 className="text-2xl font-bold text-gray-900 capitalize">{title}</h1>
        </div>
    )
}

export default PageHead